import {useCallback, useReducer, useState} from 'react';

import {useInterval} from './useInterval';

export function useReCaptcha() {
    const [recaptcha, setRecaptcha] = useState<string | null>(null);

    // 1. `triggerRecaptchaRefresh` is called, which updates `lastRecaptchaRefresh`
    // 2. the new `lastRecaptchaRefresh` is passed to the <GoogleReCaptcha> component
    // 3. the <GoogleReCaptcha> component sees that the `refreshRecaptcha` prop has changed, so it
    //    triggers a refresh
    const [lastRecaptchaRefresh, triggerRecaptchaRefresh] = useReducer(
        (_: number) => Date.now(),
        Date.now()
    );

    const handleRecaptchaVerify = useCallback((token: string) => setRecaptcha(token), []);

    useInterval(() => triggerRecaptchaRefresh(), 1000 * 55 * 2); // recaptcha token expires every 2 minutes

    return {recaptcha, lastRecaptchaRefresh, triggerRecaptchaRefresh, handleRecaptchaVerify};
}

export const recaptchaActionForRegistration = 'registration';
export const recaptchaActionForLogin = 'login';
